import { create } from 'zustand';

export interface Toast {
  id: number;
  kind: 'info' | 'error' | 'ok';
  text: string;
  /** Knopf im Hinweis (z. B. „Neue Zeit setzen“); ein Klick führt ihn aus und schließt den Hinweis */
  action?: { label: string; run: () => void };
}

interface ToastState {
  toasts: Toast[];
  push: (kind: Toast['kind'], text: string, ms?: number, action?: Toast['action']) => void;
  dismiss: (id: number) => void;
}

let next = 1;

export const useToasts = create<ToastState>((set, get) => ({
  toasts: [],
  push: (kind, text, ms = kind === 'error' ? 8000 : 3500, action) => {
    const id = next++;
    set((s) => ({ toasts: [...s.toasts, { id, kind, text, ...(action ? { action } : {}) }] }));
    setTimeout(() => get().dismiss(id), ms);
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

export const toast = {
  info: (t: string, ms?: number) => useToasts.getState().push('info', t, ms),
  ok: (t: string) => useToasts.getState().push('ok', t),
  error: (t: string) => useToasts.getState().push('error', t),
  /** Hinweis mit einem Knopf; bleibt länger stehen, damit man ihn lesen und nutzen kann */
  action: (t: string, label: string, run: () => void, ms = 12000) => useToasts.getState().push('info', t, ms, { label, run }),
};
